"use client";

import { Loader2 } from "lucide-react";

interface PaymentPollingOverlayProps {
  isVisible: boolean;
  onCancel: () => void;
}

export default function PaymentPollingOverlay({
  isVisible,
  onCancel,
}: PaymentPollingOverlayProps) {
  if (!isVisible) return null;

  return (
    <div className="absolute inset-0 bg-white/95 dark:bg-gray-900/95 flex flex-col items-center justify-center z-50 rounded-lg">
      <Loader2 className="w-12 h-12 text-primary animate-spin mb-4" />
      <p className="text-lg font-semibold mb-2">결제 확인 중...</p>
      <p className="text-sm text-muted-foreground text-center px-6 leading-relaxed">
        결제를 완료하셨다면 잠시만 기다려주세요.
        <br />
        자동으로 확인됩니다.
      </p>
      <button
        onClick={onCancel}
        className="mt-6 text-sm text-muted-foreground hover:text-foreground underline transition-colors"
      >
        취소
      </button>
    </div>
  );
}
